module.exports = __webpack_public_path__ + "static/hawk-c8dd4f6fe08e81dc13ca86e85e9d641b.jpg";